import React from "react";
import { Highlight } from "react-instantsearch-dom";
import PropTypes from "prop-types";
import classNames from "classnames";
import ConditionalRender from "../utility/ConditionalRender";
import settings from "../../settings";
import styles from "./index.module.css";

const Hit = ({ hit }) => {
  const conditionalFields = [
    "video_release_date",
    "release_date",
    "event_date",
    "location"
  ];

  return (
    <article className={classNames(styles.hit)}>
      <a
        href={hit.url}
        target="_blank"
        rel="noopener noreferrer"
        className="tw-flex tw-flex-col tw-no-underline hover:tw-no-underline tw-text-black hover:tw-text-black"
      >
        <div
          className={classNames(
            styles.hitImage,
            "tw-bg-gray-200 tw-object-cover tw-mb-3 tw-overflow-hidden tw-bg-cover tw-bg-center tw-relative"
          )}
          style={{
            paddingBottom: "60%"
          }}
        >
          <img
            src={
              hit.image
                ? hit.image
                : `${settings.baseURL}images/default-image.jpg`
            }
            loading="lazy"
            alt={hit.title}
            className="tw-inset-0 tw-absolute tw-object-cover tw-w-full tw-h-full tw-object-center tw-max-w-full"
          />
        </div>
        <div className="tw-py-2">
          <div className="tw-font-bold tw-leading-tight tw-mb-1 hover:tw-text-black hover:tw-text-blue-500">
            <Highlight attribute="title" hit={hit} />
          </div>

          <div className={classNames(styles.hitDates, "tw-text-xs tw-text-gray-600 tw-font-light tw-flex tw-flex-wrap tw-leading-none")}>
            {conditionalFields.map((f, i) => (
              <ConditionalRender shouldRender={f in hit} key={i}>
                <div
                  className={classNames(
                    "tw-mb-1",
                    styles.hitDatesItem
                  )}
                >
                  {hit[f]}
                </div>
              </ConditionalRender>
            ))}
          </div>

          <ConditionalRender shouldRender={hit.description}>
            <div className="tw-text-xs tw-font-light tw-mt-2">
              <Highlight className="tw-text-xs" attribute="description" hit={hit} />
            </div>
          </ConditionalRender>

          <ConditionalRender shouldRender={hit.hostname}>
            <div className="tw-text-xs tw-mt-2 tw-text-gray-500">
              {hit.hostname}
            </div>
          </ConditionalRender>
        </div>
      </a>
    </article>
  );
};

Hit.propTypes = {
  hit: PropTypes.object.isRequired
};

export default React.memo(Hit);
